import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-live"];
const _hoisted_2 = {
  class: "ds-field-feedback__text"
};
export default {
  __name: 'FieldFeedback',
  props: {
    message: {
      type: String,
      default: ''
    },
    tone: {
      type: String,
      default: 'error',
      validator: v => ['error', 'warning', 'success', 'info'].includes(v)
    },
    /** 可选文本按钮（如「去充值」） */
    actionLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['action'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return __props.message ? (_openBlock(), _createElementBlock("p", {
        key: 0,
        class: _normalizeClass(["ds-field-feedback", `ds-field-feedback--${__props.tone}`]),
        role: "alert",
        "aria-live": __props.tone === 'error' ? 'assertive' : 'polite'
      }, [_createElementVNode("span", _hoisted_2, _toDisplayString(__props.message), 1), __props.actionLabel ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "ds-field-feedback__action",
        onClick: _cache[0] || (_cache[0] = $event => emit('action'))
      }, _toDisplayString(__props.actionLabel), 1)) : _createCommentVNode("", true)], 10, _hoisted_1)) : _createCommentVNode("", true);
    };
  }
};